import { useCallback, useState } from 'react';

import type { EditorActions } from '@atlaskit/editor-core';

import { checkFeatureGate } from '../services/feature-flag';
import { getAllSmartLinks } from '../services/links';

export const useInviteFromLinkExperimentEditor = () => {
	const [startingLinks, setStartingLinks] = useState<Set<string>>();

	const onEditorReady = useCallback(async (editorActions: EditorActions) => {
		const adf = await editorActions.getValue();
		const links = getAllSmartLinks(adf);
		setStartingLinks(links);
	}, []);

	return {
		onEditorReady: checkFeatureGate() ? onEditorReady : undefined,
		startingLinks,
	};
};
